import { render, staticRenderFns } from "./CustomerViewDetailsTab.vue?vue&type=template&id=4ba5f308"
import script from "./CustomerViewDetailsTab.vue?vue&type=script&lang=js"
export * from "./CustomerViewDetailsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports